import { render, staticRenderFns } from "./BankPayment.vue?vue&type=template&id=2d8f65d4&scoped=true&"
import script from "./BankPayment.vue?vue&type=script&lang=js&"
export * from "./BankPayment.vue?vue&type=script&lang=js&"
import style0 from "./BankPayment.vue?vue&type=style&index=0&id=2d8f65d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8f65d4",
  null
  
)

export default component.exports